<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>人全外显子组测序</h1>-->
<!--          <h2 class="mt10">Whole Exome Sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>人全外显子组测序</h1>
      <h2 class="mt10">Human Whole Exome Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">外显子是人基因组的蛋白编码区域，集中了大部分疾病的致病突变位点，全外显子组测序（Whole Exome Sequencing，WES）是指利用序列捕获或者靶向技术将全基因组外显子区域 DNA 富集后再进行高通量测序的基因组分析方法。与全基因组重测序相比，全外显子组测序只需针对外显子区域的基因序列测序，覆盖度更深、数据准确性更高，更加简便、经济、高效。相比全基因组测序，全外显子测序更加经济、高效。外显子组测序主要用于识别和研究与疾病、种群进化相关的编码区及UTR区域内的结构变异。</p>
      <div class="c-title">应用领域</div>
      <div class="con">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/whole_icon_5.png">
            <p>可变剪接</p>
          </li>
          <li>
            <img src="@/assets/images/full_icon_2.png">
            <p>融合基因</p>
          </li>
          <li>
            <img src="@/assets/images/prokaryotic_icon_1.png">
            <p>新转录本新内含子</p>
          </li>
          <li>
            <img src="@/assets/images/target_icon_3.png">
            <p>全长转录组</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_3.png">
            <p>异构体</p>
          </li>
          <li>
            <img src="@/assets/images/whole_icon_6.png">
            <p>novel基因</p>
          </li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/whole_icon_5.png">
            <p>可变剪接</p>
          </li>
          <li>
            <img src="@/assets/images/full_icon_2.png">
            <p>融合基因</p>
          </li>
          <li>
            <img src="@/assets/images/prokaryotic_icon_1.png">
            <p>新转录本新内含子</p>
          </li>
          <li>
            <img src="@/assets/images/target_icon_3.png">
            <p>全长转录组</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_3.png">
            <p>异构体</p>
          </li>
          <li>
            <img src="@/assets/images/whole_icon_6.png">
            <p>novel基因</p>
          </li>
        </ul>
      </div>
      <div class="c-title">技术参数</div>
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>HiSeq/Novaseq PE150DNBSEQ T7 PE150</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_5.png">
          <h4>项目周期</h4>
          <p>30天</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>10G(100×)</p>
        </li> -->
        <li>
          <img src="@/assets/images/target_icon_5.png">
          <h4>捕获试剂盒</h4>
          <p>Agilent SureSelect V6IDT All Exon</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png">
          <h4>数据质量</h4>
          <p>Q30 > 80%</p>
        </li>
      </ul>
      <div class="c-title">项目流程</div>
      <div class="tc con"><img src="@/assets/images/whole_3.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/whole_3.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/whole_exome.vue